import { Alert, Grid } from '@mui/material'

import {
  useGetDriverAppFulfilmentPriceChartQuery,
  useGetDriverAppFulfilmentReasonsQuery,
  useGetDriverAppFulfilmentSummaryQuery,
  useGetDriverAppFulfilmentTrendQuery,
} from 'generated/graphql'

import { DriverAppFulfilmentHistoryNote } from './DriverAppFulfilmentHistoryNote'
import { DriverAppFulfilmentSummary } from './DriverAppFulfilmentSummary'
import { FailureReasonsCard } from './FailureReasonsCard'
import { FulfilmentTrendCard } from './FulfilmentTrendCard'
import { PriceDifferenceCard } from './PriceDifferenceCard'
import { useDriverAppFulfilmentQueryInput } from './useDriverAppFulfilmentQueryInput'

export const DriverAppFulfilmentCards = () => {
  const { start, hasValidRange, isCustom, input } = useDriverAppFulfilmentQueryInput()

  const queryOptions = {
    variables: { input },
    skip: !hasValidRange,
    notifyOnNetworkStatusChange: true,
    nextFetchPolicy: 'cache-and-network' as const,
  }

  const summary = useGetDriverAppFulfilmentSummaryQuery(queryOptions)
  const reasons = useGetDriverAppFulfilmentReasonsQuery(queryOptions)
  const priceChart = useGetDriverAppFulfilmentPriceChartQuery(queryOptions)
  const trend = useGetDriverAppFulfilmentTrendQuery(queryOptions)

  const summaryData =
    summary.data?.driverAppFulfilmentSummary ?? summary.previousData?.driverAppFulfilmentSummary
  const reasonsData =
    reasons.data?.driverAppFulfilmentReasons ?? reasons.previousData?.driverAppFulfilmentReasons
  const priceChartData =
    priceChart.data?.driverAppFulfilmentPriceChart ??
    priceChart.previousData?.driverAppFulfilmentPriceChart
  const trendData =
    trend.data?.driverAppFulfilmentTrend ?? trend.previousData?.driverAppFulfilmentTrend

  const hasError = summary.error || reasons.error || priceChart.error || trend.error

  if (!hasValidRange) {
    return (
      <Alert severity='info'>
        {isCustom
          ? 'Choose a From and To date to see the metrics.'
          : 'Choose a period to see the metrics.'}
      </Alert>
    )
  }

  return (
    <Grid container spacing={3}>
      {hasError && (
        <Grid item xs={12}>
          <Alert severity='error'>Could not load the Driver App fulfilment metrics.</Alert>
        </Grid>
      )}

      <Grid item xs={12}>
        <DriverAppFulfilmentHistoryNote start={start} />
      </Grid>

      <Grid item xs={12}>
        <DriverAppFulfilmentSummary
          summary={summaryData}
          loading={summary.loading && !summaryData}
        />
      </Grid>

      <Grid item xs={12}>
        <FailureReasonsCard data={reasonsData} loading={reasons.loading && !reasonsData} />
      </Grid>

      <Grid item xs={12}>
        <PriceDifferenceCard
          data={priceChartData}
          loading={priceChart.loading && !priceChartData}
        />
      </Grid>

      <Grid item xs={12}>
        <FulfilmentTrendCard data={trendData} loading={trend.loading && !trendData} />
      </Grid>
    </Grid>
  )
}
